import { useEffect, useState } from "react";
import { toast } from "sonner";
import { useApi, errMsg } from "@/lib/api";
import { clearSettingsCache } from "@/lib/useSettings";
import { PageHeader } from "@/components/portal/StatusBadge";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const FIELDS = [["facebook", "Facebook page"], ["instagram", "Instagram"], ["tiktok", "TikTok"], ["youtube", "YouTube"], ["google", "Google Business / reviews"], ["nextdoor", "Nextdoor"]];

export default function SocialSettings() {
  const api = useApi();
  const [f, setF] = useState(null);
  useEffect(() => {
    api("get", "/settings").then(setF);
  }, [api]);

  const save = async (e) => {
    e.preventDefault();
    try {
      setF(await api("put", "/settings", f));
      clearSettingsCache();
      toast.success("Social links saved — they now show on the website");
    } catch (err) {
      toast.error(errMsg(err));
    }
  };

  if (!f) return null;
  return (
    <div data-testid="social-page">
      <PageHeader eyebrow="Website" title="Social media" />
      <p className="mb-6 max-w-2xl text-sm text-[#5C5850]">Paste the full link to each page (starting with https://). Filled-in links appear as icons in the website footer. Leave blank to hide.</p>
      <form onSubmit={save} className="grid max-w-3xl gap-4 rounded-2xl border border-[#E6E2DA] bg-white p-6 sm:grid-cols-2" data-testid="social-form">
        {FIELDS.map(([k, l]) => (
          <div key={k} className="space-y-1.5">
            <Label className="text-xs">{l}</Label>
            <Input value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} placeholder="https://" data-testid={`social-input-${k}`} />
          </div>
        ))}
        <button className="rounded-full bg-[#F2B91C] py-3 text-sm font-bold text-[#0E1F3F] hover:bg-[#D9A30F] sm:col-span-2" data-testid="social-save-btn">Save links</button>
      </form>
    </div>
  );
}
